import React from 'react'
import clsx from 'clsx'
import DirectionsCarOutlinedIcon from '@material-ui/icons/DirectionsCarOutlined'
import Directions from '@material-ui/icons/Directions'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ChevronRight from '@material-ui/icons/ChevronRight'

import NavigationRounded from '@material-ui/icons/NavigationRounded'
import {
  Button,
  List,
  ListSubheader,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Collapse,
  Divider,
} from '@material-ui/core'
import {
  setDestination,
  setDirections,
  setOrigin,
  showDirections,
} from '../../redux/myMapsSlice'
import AutoCompleteSearchbar from './AutoCompleteSearchbar'
import CheckIsMobile from '../../../../../../../utils/isMobileHook'

const NavigationContent = ({
  dispatch,
  classes,
  showDirectionsButton,
  handleUpdateShowDirections,
  destination,
  directionRoutes,
  updateNavigationRoute,
  directionStepsRef,
  darkMode,
}) => {
  const isMobile = CheckIsMobile()
  const [selectedRouteIndex, updateSelectedRouteIndex] = React.useState(0)
  const handleNaviationButtonClick = () => {
    dispatch(showDirections())
  }
  React.useEffect(() => {
    // reset the index and directions if the destination changes.
    updateSelectedRouteIndex(0)
    dispatch(setDirections(false))
  }, [destination])
  React.useEffect(() => {
    if (isMobile && directionRoutes?.length > 0) {
      directionStepsRef?.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      })
    }
  }, [isMobile, directionRoutes])
  return (
    <div className={classes.getDirectionsContainer}>
      {!showDirectionsButton ? (
        <div className={classes.getDirectionsButtonContainer}>
          <Button
            variant="contained"
            color="primary"
            className={classes.getDirectionsButton}
            onClick={handleUpdateShowDirections}
          >
            <Directions />
            <Typography
              variant="body2"
              className={classes.getDirectionsButtonText}
            >
              Get Directions
            </Typography>
          </Button>
        </div>
      ) : (
        <>
          <Typography
            variant="subtitle1"
            className={clsx(classes.campusText, classes.directionsSubtitle)}
          >
            Directions
          </Typography>
          <div>
            <div className={classes.directionsInputContainer}>
              <Typography variant="body1" className={classes.originLabel}>
                Origin:
              </Typography>
              <AutoCompleteSearchbar
                placeholder="Start"
                label="A"
                dispatch={dispatch}
                dispatchAction={setOrigin}
                enableGeolocationButton
                darkMode={darkMode}
              />
            </div>
            <div className={classes.directionsInputContainer}>
              <Typography variant="body1" className={classes.destinationLabel}>
                Destination:
              </Typography>
              <AutoCompleteSearchbar
                placeholder="End"
                label="B"
                dispatch={dispatch}
                dispatchAction={setDestination}
                destination={destination}
                darkMode={darkMode}
              />
            </div>
            <div className={classes.navigateButtonContainer}>
              <Button
                color="primary"
                variant="contained"
                size="medium"
                onClick={handleNaviationButtonClick}
                className={classes.navigateButton}
                style={{ marginBottom: 10 }}
              >
                <NavigationRounded />
                <Typography variant="subtitle1">Navigate</Typography>
              </Button>
            </div>
            {directionRoutes?.length > 0 ? (
              <div className={classes.directionsAddressContainer}>
                <div className={classes.directionsAddressContainer}>
                  <Typography variant="body1">
                    {directionRoutes[0].legs[0].start_address.split(',')[0]} to{' '}
                    {directionRoutes[0].legs[0].end_address.split(',')[0]}
                  </Typography>
                </div>
                <List
                  aria-labelledby="Other routes"
                  subheader={
                    <ListSubheader
                      component="div"
                      id="other-routes-header"
                      className={classes.alternateRouteLabel}
                    >
                      Alternate Routes
                    </ListSubheader>
                  }
                >
                  {directionRoutes?.map((route, index) => (
                    <React.Fragment key={route.summary}>
                      <ListItem disableGutters>
                        <Button
                          color="primary"
                          variant={
                            selectedRouteIndex === index
                              ? 'contained'
                              : 'outlined'
                          }
                          onClick={() => {
                            updateNavigationRoute(index)
                            updateSelectedRouteIndex(index)
                          }}
                          className={
                            selectedRouteIndex === index
                              ? classes.routesButtonEnabled
                              : classes.routesButton
                          }
                        >
                          <ListItemIcon>
                            <DirectionsCarOutlinedIcon
                              htmlColor={
                                selectedRouteIndex === index
                                  ? '#ffffff'
                                  : '#cc5500'
                              }
                            />
                          </ListItemIcon>
                          <ListItemText primary={route.summary} />
                          {selectedRouteIndex === index ? (
                            <ExpandLessIcon />
                          ) : (
                            <ExpandMoreIcon />
                          )}
                        </Button>
                      </ListItem>
                      <Collapse
                        in={selectedRouteIndex === index}
                        timeout="auto"
                        unmountOnExit
                      >
                        <div ref={directionStepsRef} />
                        <List component="div">
                          {route?.legs[0]?.steps?.map((step) => (
                            <div
                              key={step.instructions}
                              className={classes.routeStepsContainer}
                            >
                              <ChevronRight style={{ marginRight: 10 }} />
                              <div
                                className={
                                  classes.routeStepsInstructionsContainer
                                }
                              >
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: step.instructions,
                                  }}
                                  style={{ marginTop: 10 }}
                                />
                                <Divider
                                  orientation="horizontal"
                                  style={{ marginTop: 10 }}
                                />
                              </div>
                            </div>
                          ))}
                        </List>
                      </Collapse>
                    </React.Fragment>
                  ))}
                </List>
              </div>
            ) : null}
          </div>
        </>
      )}
    </div>
  )
}

export default NavigationContent
